// extracted by mini-css-extract-plugin
export var accordion = "_ct-0";
export var chevron = "_ct-3";
export var closed = "_ct-2";
export var content = "_ct-4";
export var open = "_ct-1";
export var rotate = "_ct-5";